import type { ChartData } from '../../types.tsx';

export const evaluateTargetDependencyDate = (targetItem: ChartData) => {
	const { startDate: start, dueDate: due } = targetItem;

	if (due !== undefined && start !== undefined && due < start) {
		return due;
	}
	return start;
};

export const evaluateSourceDependencyDate = (sourceItem: ChartData) => {
	const { startDate: start, dueDate: due } = sourceItem;

	if (due !== undefined && start !== undefined && due < start) {
		return start;
	}
	return due;
};
